export default __webpack_public_path__ + "6f84144edebfaae4ee8328a368a00544.wav";